export interface TenantIdentity {
  code?: string;
  id?: number;
}

/**
 * Maps tenant identity from auth/localStorage to tenant-config bundle ids.
 *
 * Priority:
 * 1. Explicit alias table (tenant.code -> config tenantId)
 * 2. tenant.code as-is
 * 3. tenant.id as string
 * 4. environment fallback / "default"
 */
const TENANT_CONFIG_ALIASES: Record<string, string> = {
  acme: 'tenant-acme',
};

export function resolveExperienceTenantId(
  tenant: TenantIdentity | null | undefined,
  fallback = 'default',
): string {
  if (tenant?.code) {
    const normalized = tenant.code.trim();
    const alias = TENANT_CONFIG_ALIASES[normalized.toLowerCase()];
    return alias ?? normalized;
  }
  if (tenant?.id != null) {
    return String(tenant.id);
  }
  return fallback;
}
